import { TypeAnimation } from 'react-type-animation'

export default function Animation () {
  return (
    <>
      <TypeAnimation
        // Same String at the start will only be typed once, initially
        sequence={[
          'Software Engineer',
          1000,
          'Full Stack Engineer',
          1000,
          'Front-End Developer',
          1000,
          'Back-End Developer',
          1000,
          'Project Manager',
          1000,
          'Scrum Master',
          1000
        ]}
        speed={40} // Custom Speed from 1-99 - Default Speed: 40
        className='
        text-[25px]
        self-center'
        wrapper='span' // Animation will be rendered as a <span>
        repeat={Infinity}
      />
    </>
  )
}
